/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	
	  (0, _module.preLoad)();
	  (0, _module.anchorLink)();
	  (0, _module.loadAnimate)();
	  (0, _module.scrollAnimate)();
	  (0, _module.resizeHeader)();
	  (0, _module.moreBtn)();
	  (0, _module.termToggle)();
	  (0, _module.toggleMenu)();
	  (0, _module.accordion)();
	  (0, _module.bnr)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	// console.log(windowWidth);
	// console.log(windowHeight);
	// console.log("windowWidthJ：" + windowWidthJ);
	
	
	// ------------------------------------------------------------------------
	// preLoad
	// ----- BOTH
	// ------------------------------------------------------------------------
	var preLoad = function preLoad() {
	  $(window).on("load", function () {
	    $("body").removeClass("preload");
	  });
	  setTimeout(function () {
	    $("body").removeClass("preload");
	  }, 9000);
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 100;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	  $(function () {
	    // 別ページの場合は以下
	    var urlHash = location.hash;
	    if (urlHash) {
	      $('body,html').stop().scrollTop(0);
	      setTimeout(function () {
	        // ヘッダー固定の場合はヘッダーの高さを数値で入れる、固定でない場合は0
	        var headerHight = 100;
	        var target = $(urlHash);
	        var position = target.offset().top - headerHight;
	        $('body,html').stop().animate({
	          scrollTop: position
	        }, 800);
	      }, 100);
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	var scrollBanner = function scrollBanner() {
	  $(window).on("scroll", function () {
	    var scrollPosition = $(window).scrollTop();
	    // if(windowW >= 768){
	    if (scrollPosition >= 100) {
	      // $(".sw-Scroll-Banner").removeClass('sw-Scroll-Banner_Hidden');
	    } else {}
	      // $(".sw-Scroll-Banner").addClass('sw-Scroll-Banner_Hidden');
	
	      // }
	  });
	
	  // $("#st-Top,#footer-top").on("click", function(){
	  //   var linkSpeed    = 500;
	  //   $("html, body").animate({scrollTop: 0}, linkSpeed, "easeOutQuint");
	  //   return false;
	  // });
	};
	
	// ------------------------------------------------------------------------
	// slideBanner
	// ----- BOTH
	// ------------------------------------------------------------------------
	var slideBanner = function slideBanner() {
	  setTimeout(function () {
	    $('.slider-banner').slick({
	      lazyLoad: 'progressive',
	      slidesToShow: 2,
	      slidesToScroll: 1,
	      arrows: true,
	      dots: true,
	      autoplay: true,
	      speed: 500,
	      cssEase: 'ease',
	      variableWidth: true,
	      prevArrow: '<button class="slick-prev slick-arrow"></button>',
	      nextArrow: '<button class="slick-next slick-arrow"></button>',
	      responsive: [{
	        breakpoint: 768,
	        settings: {
	          slidesToShow: 1,
	          slidesToScroll: 1,
	          arrows: false,
	          centerMode: true,
	          swipeToSlide: true,
	          swipe: true,
	          edgeFriction: 0.01
	        }
	      }]
	    });
	    windowWidthJ = $(window).width();
	    var slide = $('.slider-banner .slick-slide').length;
	    // console.log("スライド枚数：" + slide);
	    if (windowWidthJ < 768) {
	      // console.log("スマホ用");
	      if (slide < 2) {
	        // console.log("スライダー壊しますsp");
	        $('.slider-banner').slick('unslick');
	      }
	    } else {
	      // console.log("PC用");
	      if (slide < 2) {
	        // console.log("スライダー壊します");
	        $('.slider-banner').slick('unslick');
	      } else if (slide == 2) {
	        // console.log("ページャー消す");
	        $('.slick-dots').hide();
	      }
	    }
	    $('.idx-Banner').hide().fadeIn();
	  }, 2000);
	  $(window).resize(function () {
	    windowWidthJ = $(window).width();
	    var slide = $('.slick-slide').length;
	    // console.log("スライド枚数2：" + slide);
	    if (windowWidthJ < 768) {
	      // console.log("スマホ用");
	      // if(slide < 2){
	      //   console.log("スライダー壊しますsp");
	      //   $('.slider-banner').slick('unslick');
	      // }
	    } else {
	      // console.log("PC用");
	      if (slide < 2) {
	        // console.log("スライダー壊します");
	        // $('.slider-banner').slick('unslick');
	      } else if (slide == 2) {
	        // console.log("ページャー消す");
	        $('.slick-dots').hide();
	      }
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// slideArtist
	// ----- BOTH
	// ------------------------------------------------------------------------
	var slideArtist = function slideArtist() {
	  $('.slider-artist').slick({
	    slidesToShow: 3,
	    slidesToScroll: 1,
	    arrows: true,
	    dots: false,
	    speed: 500,
	    autoplay: true,
	    autoplaySpeed: 3000,
	    cssEase: 'ease',
	    variableWidth: true,
	    prevArrow: '<button class="slick-prev slick-arrow"></button>',
	    nextArrow: '<button class="slick-next slick-arrow"></button>',
	    responsive: [{
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        swipeToSlide: true,
	        swipe: true,
	        edgeFriction: 0.01
	      }
	    }]
	  });
	};
	
	// ------------------------------------------------------------------------
	// scrollAnimate
	// ----- BOTH
	// ------------------------------------------------------------------------
	var scrollAnimate = function scrollAnimate() {
	  $(window).on('scroll load', function () {
	    $('.ja-s').each(function () {
	      var targetPos = $(this).offset().top;
	      var scrollPos = $(window).scrollTop();
	      var windowHeight = $(window).height();
	      if (scrollPos > targetPos - windowHeight + windowHeight / 4) {
	        $(this).addClass("animated");
	      }
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// loadAnimate
	// ----- BOTH
	// ------------------------------------------------------------------------
	var loadAnimate = function loadAnimate() {
	  $(window).on('load', function () {
	    $('.ja-l').each(function () {
	      $(this).addClass("animated");
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// resizeHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	var resizeHeader = function resizeHeader() {
	  $(window).on("load scroll", function () {
	    var scrollHeight = $(this).scrollTop();
	    if (scrollHeight > 200) {
	      $(".st-Header_Menu").addClass("scrolled");
	    } else {
	      $(".st-Header_Menu").removeClass("scrolled");
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// toggleAccordion
	// ----- BOTH
	// ------------------------------------------------------------------------
	var toggleAccordion = function toggleAccordion() {
	  $(".accordion-toggle").on("click", function () {
	    $(this).next().slideToggle();
	    $(this).toggleClass("open");
	  });
	};
	
	// ------------------------------------------------------------------------
	// toggleMenu
	// ----- BOTH
	// ------------------------------------------------------------------------
	var toggleMenu = function toggleMenu() {
	  $('.st-Header .hamburger button').on('click', function () {
	    $(this).toggleClass("open");
	    $(".st-Header nav").toggleClass("open");
	    $(".st-Header").toggleClass("open");
	  });
	};
	
	// ------------------------------------------------------------------------
	// loadMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	var loadMovie = function loadMovie() {
	  $(window).on('load', function () {
	    if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document) {
	      $("#video").addClass("ipad");
	    }
	    $("#video").addClass("loaded");
	  });
	  $(window).on('load', function () {
	    // let mvHeight = window.innerHeight;
	    // $(".idx-Mainvisual").css("height",mvHeight);
	    var video = document.getElementById('video');
	    video.play();
	  });
	};
	
	var moreBtn = function moreBtn() {
	  $(".more-app").on("click", function () {
	    $(this).parent(".sw-Frame").addClass("show");
	    // $(this).addClass("hide");
	    return false;
	  });
	};
	
	//termToggle
	var termToggle = function termToggle() {
	  $('.faq_List li dl dt').on('click', function () {
	    $(this).next('dd').slideToggle(100).css('display', 'block');
	    $(this).parent().toggleClass('opened');
	  });
	};
	
	// ------------------------------------------------------------------------
	// accordion
	// ------------------------------------------------------------------------
	var accordion = function accordion() {
	  $('.js-Accordion').each(function () {
	    $(this).children('.heading').on("click", function () {
	      $(this).next('.content').slideToggle();
	      $(this).toggleClass('active');
	    });
	  });
	};
	
	//バナー
	var bnr = function bnr() {
	  $("#live-Bnr .close").on("click", function () {
	    $('#live-Bnr').addClass('closed');
	  });
	};
	
	exports.preLoad = preLoad;
	exports.anchorLink = anchorLink;
	exports.scrollBanner = scrollBanner;
	exports.slideBanner = slideBanner;
	exports.slideArtist = slideArtist;
	exports.resizeHeader = resizeHeader;
	exports.toggleAccordion = toggleAccordion;
	exports.toggleMenu = toggleMenu;
	exports.loadMovie = loadMovie;
	exports.scrollAnimate = scrollAnimate;
	exports.loadAnimate = loadAnimate;
	exports.moreBtn = moreBtn;
	exports.termToggle = termToggle;
	exports.accordion = accordion;
	exports.bnr = bnr;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// audition/app.bundle.js